import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";

import classNames from "classnames";
import { useMediaQuery } from "react-responsive";
import { CURRENCY_SYMBOL } from "utils/constants";
import { costToFrench } from "utils/helpers/values";
import ActionButtons from "../Components/ActionButtons";
import Head from "../Components/Head";
import Layout from "../Components/Layout";
import lclIcon from "../Components/svg/LCL.svg";

const View = ({
  initialValues,
  totalCost,
  onSubmit,
  locked,
  onBack,
  initiatePayment,
  isRedirecting,
}) => {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.PROCESSES);
  const TRANSLATION = t("B2C_LMF.BANK_CARD", { returnObjects: true });
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const { handleSubmit, values, setFieldValue, ...formProps } = useFormik({
    initialValues,
    onSubmit,
    // validationSchema: validation(
    //   t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true })
    // ),
  });

  return (
    <>
      <Layout>
        <Head description={TRANSLATION.DESCRIPTION} title={TRANSLATION.TITLE} />
        <div className="__LMF--content LMF-content lmf__form grid--1 gap-24">
          {/* <Row gutter={[16, 16]} className="">
            <Col xs={12} sm={12} md={12} lg={12}>
              <Input
                label={TRANSLATION.FORM.CARD_NUMBER.LABEL}
                placeholder={TRANSLATION.FORM.CARD_NUMBER.PLACEHOLDER}
                className={classNames({
                  valid: get(values, `additionalInfo.bankCard.cardNumber`),
                })}
                type={"number"}
                inputMode="numeric"
                {...bindInputProps({
                  name: `additionalInfo.bankCard.cardNumber`,
                  values,
                  setFieldValue,
                  ...formProps,
                })}
                onChange={({ target: { value } }) => {
                  setFieldValue(`additionalInfo.bankCard.cardNumber`, value);
                }}
                disabled={locked}
                suffix={
                  get(
                    formProps.errors,
                    `additionalInfo.bankCard.cardNumber`
                  ) ? (
                    <img src={InputError} alt="" />
                  ) : (
                    <img src={InputChecked} alt="" />
                  )
                }
              />
            </Col>
            <Col xs={6} sm={6} md={6} lg={6}>
              <Input
                label={TRANSLATION.FORM.EXPIRATION_DATE.LABEL}
                placeholder={TRANSLATION.FORM.EXPIRATION_DATE.PLACEHOLDER}
                className={classNames({
                  valid: get(values, `additionalInfo.bankCard.expirationDate`),
                })}
                inputMode="numeric"
                maxLength={5}
                {...bindInputProps({
                  name: `additionalInfo.bankCard.expirationDate`,
                  values,
                  setFieldValue,
                  ...formProps,
                })}
                onChange={({ target: { value } }) => {
                  let cleaned = value.replace(/\D/g, "");
                  cleaned = cleaned.slice(0, 4);

                  let month = cleaned.slice(0, 2);
                  let year = cleaned.slice(2, 4);

                  if (month.length === 2) {
                    let monthNum = parseInt(month, 10);
                    if (monthNum < 1) month = "01";
                    if (monthNum > 12) month = "12";
                  }

                  let formatted = month;
                  if (year.length) {
                    formatted += "/" + year;
                  }

                  setFieldValue(
                    `additionalInfo.bankCard.expirationDate`,
                    formatted
                  );
                }}
                disabled={locked}
                suffix={
                  get(
                    formProps.errors,
                    `additionalInfo.bankCard.expirationDate`
                  ) ? (
                    <img src={InputError} alt="" />
                  ) : (
                    <img src={InputChecked} alt="" />
                  )
                }
              />
            </Col>
            <Col xs={6} sm={6} md={6} lg={6}>
              <Input
                label={TRANSLATION.FORM.CVC.LABEL}
                placeholder={TRANSLATION.FORM.CVC.PLACEHOLDER}
                className={classNames({
                  valid: get(values, `additionalInfo.bankCard.ccv`),
                })}
                type={"number"}
                inputMode="numeric"
                {...bindInputProps({
                  name: `additionalInfo.bankCard.ccv`,
                  values,
                  setFieldValue,
                  ...formProps,
                })}
                onChange={({ target: { value } }) => {
                  if (value.length > 3) return;
                  setFieldValue(`additionalInfo.bankCard.ccv`, value);
                }}
                disabled={locked}
                suffix={
                  get(formProps.errors, `additionalInfo.bankCard.ccv`) ? (
                    <img src={InputError} alt="" />
                  ) : (
                    <img src={InputChecked} alt="" />
                  )
                }
              />
            </Col>
          </Row> */}

          <ActionButtons
            disabled={isRedirecting}
            onNext={initiatePayment}
            buttonText={
              <>
                {TRANSLATION.PAY} {costToFrench(totalCost)}{" "}
                {CURRENCY_SYMBOL.EUR}
              </>
            }
            // {...(isMobile && { onBack })}
            className={classNames({
              "w-100": isMobile,
            })}
          />

          {/* {isRedirecting && (
            <>
              <Button
                onClick={() => window.location.reload()}
                type={"primary"}
                size="large"
                className="w-full"
              >
                <span>{TRANSLATION.RELOAD}</span>
              </Button>
              <p className="lmf--hint bank-card">
                {TRANSLATION.AFTER_PAYMENT_HINT}
              </p>
            </>
          )} */}
        </div>

        <p className="lmf--sponsor">
          <span>{TRANSLATION.SPONSOR}</span>
          <img src={lclIcon} alt="" />
        </p>
      </Layout>
    </>
  );
};

export default View;
